import { FileViewerType } from '../model/types';
import { ImageViewer } from './ImageViewer';
import { OtherFileViewer } from './OtherFileViewer';
import { PdfViewer } from './PdfViewer';
import { VideoViewer } from './VideoViewer';

type FileViewerSwitchProps = {
    viewerType: FileViewerType;
    fileUrl: string;
    fileName: string;
    fileSizeBytes: number;
    rotation: number;
};

export const FileViewerSwitch = ({
    viewerType,
    fileUrl,
    fileName,
    fileSizeBytes,
    rotation,
}: FileViewerSwitchProps) => (
    <>
        {viewerType === 'image' && (
            <ImageViewer src={fileUrl} alt={fileName} rotation={rotation} />
        )}
        {viewerType === 'video' && (
            <VideoViewer src={fileUrl} rotation={rotation} />
        )}
        {viewerType === 'pdf' && <PdfViewer src={fileUrl} title={fileName} />}
        {viewerType === 'other' && (
            <OtherFileViewer
                fileName={fileName}
                fileSizeBytes={fileSizeBytes}
                downloadUrl={fileUrl}
            />
        )}
    </>
);
